<template>
  <div class="content_box">
    <div class="userManage" id="ManageTable">
      <div class="userManage_header">
        <div class="userManage_logo">
          <img src="@/assets/imgs/icon/user_logo.png" alt />
        </div>
        <h3>用户管理</h3>
      </div>
      <!-- <div class="userManage_form"> -->
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="用户名称">
          <el-input
            v-model.trim="formInline.name"
            placeholder="请输入用户名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户类型">
          <el-select v-model="formInline.type" placeholder="不限">
            <el-option label="不限" value></el-option>
            <el-option label="政府用户" value="政府用户"></el-option>
            <el-option label="园区用户" value="园区用户"></el-option>
            <el-option label="企业用户" value="企业用户"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="登录账号">
          <el-input
            v-model.trim="formInline.loginName"
            placeholder="请输入登录账号"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onSubmit"
            class="bg5584FF formBotton"
            >查询</el-button
          >
          <el-button type="info" @click="reset" class="formBotton"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
      <!-- </div> -->
      <hr class="hr" />
      <div class="userManage_add_user">
        <el-button
          type="primary"
          size="small"
          @click="addDialogVisible = true"
          class="bg5584FF"
        >
          <i class="el-icon-plus"></i>新增用户
        </el-button>
      </div>
      <!-- 表格数据 -->
      <el-table
        :data="tableData"
        stripe
        style="width: 100%"
        :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
        v-loading="loading"
      >
        <el-table-column prop="name" label="用户名称" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="detail" @click="handleDetail(scope.row)">{{
              scope.row.name
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="loginName"
          label="登录账号"
          show-overflow-tooltip
          align="center"
        ></el-table-column>
        <el-table-column
          prop="type"
          label="用户类型"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="department"
          label="所属部门"
          show-overflow-tooltip
          align="center"
        ></el-table-column>
        <el-table-column label="用户状态" align="center">
          <template slot-scope="scope">{{
            scope.row.state == 0 ? "启用" : "停用"
          }}</template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="248">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              class="bg5584FF"
              @click="handleManage(scope.$index, scope.row)"
              >分配角色</el-button
            >
            <el-button
              type="primary"
              size="mini"
              class="bg5584FF"
              @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-button
              type="primary"
              size="mini"
              class="bg5584FF"
              @click="handleDelete(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pageBox">
        <!-- <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page.sync="currentPage"
          :page-size="10"
          layout="prev, pager, next, jumper"
          :total="total"
        ></el-pagination> -->
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          layout="total,  prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增用户 -->
      <el-dialog
        title="新增用户"
        :visible.sync="addDialogVisible"
        class="dialog770 titleChange"
        :close-on-click-modal="false"
        @closed="addDialogHandleClose"
      >
        <div class="addUser">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="95px"
            class="demo-ruleForm"
            size="small"
            v-loading="addloading"
          >
            <div
              style="
                color: red;
                line-height: 28px;
                padding-left: 14px;
                box-sizing: border-box;
                margin-bottom: 18px;
              "
            >
              ！本功能只支持新增政府用户，企业和园区用户需要通过企业库/园区库新增企业/园区同步新增对应用户
            </div>
            <el-row>
              <el-col span="12">
                <el-form-item label="用户名称：" prop="name">
                  <el-input
                    v-model.trim="ruleForm.name"
                    placeholder="请输入用户名称"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="登录账号：" prop="loginName">
                  <el-input
                    v-model.trim="ruleForm.loginName"
                    placeholder="请输入登录账号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="用户类型：">
                  <el-select
                    v-model="ruleForm.type"
                    placeholder="政府用户"
                    disabled
                  >
                    <el-option label="政府用户" value="政府用户"></el-option>
                    <!-- <el-option label="园区用户" value="园区用户"></el-option> -->
                    <!-- <el-option label="企业用户" value="企业用户"></el-option> -->
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="所属部门：" prop="department">
                  <el-select
                    v-model="ruleForm.department"
                    placeholder="请选择部门"
                  >
                    <el-option
                      v-for="item in superDepartmentList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="用户状态：" prop="state">
                  <el-radio-group v-model="ruleForm.state">
                    <el-radio :label="0">启用</el-radio>
                    <el-radio :label="1">停用</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="手机号码：" prop="mobilePhone">
                  <el-input
                    v-model.trim="ruleForm.mobilePhone"
                    placeholder="请输入手机号码"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="座机号码：">
                  <el-input
                    v-model.trim="ruleForm.landLine"
                    placeholder="请输入座机号码"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="联系邮箱：">
                  <el-input
                    v-model.trim="ruleForm.email"
                    placeholder="请输入联系邮箱"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="btnBox">
            <el-button type="primary" @click="submitForm('ruleForm')"
              >保存</el-button
            >
            <el-button @click="addDialogVisible = false">取消</el-button>
          </div>
        </div>
      </el-dialog>
      <!-- 查看用户 -->
      <el-dialog
        title="查看用户"
        :visible.sync="detailDialogVisible"
        class="dialog770 titleChange"
        :close-on-click-modal="false"
      >
        <div class="addUser">
          <el-form
            :model="editRuleForm"
            ref="editRuleForm"
            label-width="135px"
            class="demo-RuleForm"
            size="small"
          >
            <el-row>
              <el-col span="12">
                <el-form-item label="用户名称：" prop="name">
                  <el-input
                    v-model="editRuleForm.name"
                    placeholder="请输入用户名称"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="登录账号：" prop="loginName">
                  <el-input
                    v-model="editRuleForm.loginName"
                    placeholder="请输入登录账号"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="用户类型：" prop="type">
                  <el-select
                    v-model="editRuleForm.type"
                    placeholder="请选择用户类型"
                    disabled
                  >
                    <el-option label="政府用户" value="政府用户"></el-option>
                    <el-option label="园区用户" value="园区用户"></el-option>
                    <el-option label="企业用户" value="企业用户"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item
                  label="所属部门："
                  prop="department"
                  v-if="editRuleForm.type == '政府用户'"
                >
                  <el-select
                    v-model="editRuleForm.department"
                    placeholder="请选择部门"
                    disabled
                  >
                    <el-option label="区域一" value="shanghai"></el-option>
                    <el-option label="区域二" value="beijing"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item
                  label="所属园区："
                  prop="garden"
                  v-if="editRuleForm.type == '园区用户'"
                >
                  <el-select
                    v-model="editRuleForm.garden"
                    placeholder="请选择园区"
                    disabled
                  >
                    <el-option label="区域一" value="shanghai"></el-option>
                    <el-option label="区域二" value="beijing"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item
                  label="所属企业："
                  prop="creditCode"
                  v-if="editRuleForm.type == '企业用户'"
                >
                  <el-input
                    v-model="editRuleForm.creditCode"
                    placeholder="请输入统一社会信用代码"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="用户状态：" prop="state">
                  <el-radio-group v-model="editRuleForm.state" disabled>
                    <el-radio :label="0">启用</el-radio>
                    <el-radio :label="1">停用</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="手机号码：">
                  <el-input
                    v-model="editRuleForm.mobilePhone"
                    placeholder
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="座机号码：">
                  <el-input
                    v-model="editRuleForm.landLine"
                    placeholder
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="联系邮箱：">
                  <el-input
                    v-model="editRuleForm.email"
                    placeholder
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-dialog>
      <!-- 分配角色 -->
      <el-dialog
        title="分配角色"
        :visible.sync="allotDialogVisible"
        class="dialog770 titleChange"
        :close-on-click-modal="false"
        @closed="allotHandleClose"
      >
        <el-table
          :data="userAllotTableData"
          ref="multipleTable"
          style="width: 100%"
          :header-cell-style="{
            backgroundColor: 'rgb(90, 161, 226)',
            color: '#fff',
          }"
          height="420"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column
            align="center"
            prop="name"
            label="角色名称"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="code"
            label="代码"
          ></el-table-column>
          <el-table-column align="center" label="状态">
            <template slot-scope="scope">{{
              scope.row.state == 0 ? "启用" : "禁用"
            }}</template>
          </el-table-column>
        </el-table>
        <div class="btnBox">
          <el-button
            type="primary"
            size="mini"
            class="bg5584FF"
            @click="onSaveAllot"
            >保存</el-button
          >
          <el-button
            type="normal"
            size="mini"
            @click="allotDialogVisible = false"
            >取消</el-button
          >
        </div>
      </el-dialog>
      <!-- 编辑用户 -->
      <el-dialog
        title="编辑用户"
        :visible.sync="editDialogVisible"
        class="dialog770 titleChange"
        :close-on-click-modal="false"
        @closed="editHandleClose"
      >
        <div class="addUser">
          <el-form
            :model="editRuleForm"
            :rules="rules"
            ref="editRuleForm"
            label-width="135px"
            class="demo-RuleForm"
            size="small"
            v-loading="editloading"
          >
            <el-row>
              <el-col span="12">
                <el-form-item label="用户名称：" prop="name">
                  <el-input
                    v-model.trim="editRuleForm.name"
                    placeholder="请输入用户名称"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="登录账号：">
                  <el-input
                    v-model.trim="editRuleForm.loginName"
                    placeholder="请输入登录账号"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="用户类型：">
                  <el-select
                    v-model="editRuleForm.type"
                    placeholder="请选择用户类型"
                    disabled
                  >
                    <el-option label="政府用户" value="政府用户"></el-option>
                    <el-option label="园区用户" value="园区用户"></el-option>
                    <el-option label="企业用户" value="企业用户"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item
                  label="所属部门："
                  prop="department"
                  v-if="editRuleForm.type == '政府用户'"
                >
                  <el-select
                    v-model="editRuleForm.department"
                    placeholder="请选择部门"
                  >
                    <el-option
                      v-for="item in superDepartmentList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item
                  label="所属园区："
                  prop="garden"
                  v-if="editRuleForm.type == '园区用户'"
                >
                  <el-select
                    v-model="editRuleForm.garden"
                    placeholder="请选择园区"
                  >
                    <el-option
                      v-for="item in superParktList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item
                  label="所属企业："
                  prop="creditCode"
                  v-if="editRuleForm.type == '企业用户'"
                >
                  <el-input
                    v-model.trim="editRuleForm.creditCode"
                    placeholder="请输入统一社会信用代码"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="用户状态：" prop="state">
                  <el-radio-group v-model="editRuleForm.state">
                    <el-radio :label="0">启用</el-radio>
                    <el-radio :label="1">停用</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="手机号码：" prop="mobilePhone">
                  <el-input
                    v-model.trim="editRuleForm.mobilePhone"
                    placeholder="请输入手机号码"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="座机号码：">
                  <el-input
                    v-model.trim="editRuleForm.landLine"
                    placeholder="请输入座机号码"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="联系邮箱：">
                  <el-input
                    v-model.trim="editRuleForm.email"
                    placeholder="请输入联系邮箱"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="btnBox">
            <el-button type="primary" @click="editSubmitForm('editRuleForm')"
              >保存</el-button
            >
            <el-button @click="editDialogVisible = false">取消</el-button>
          </div>
        </div>
      </el-dialog>
      <!-- 删除弹框 -->
      <el-dialog
        title="删除"
        :visible.sync="deleteDialogVisible"
        class="delete"
        :close-on-click-modal="false"
      >
        <p>确认要删除该条数据？此操作不可逆</p>
        <div class="btnBox MT40">
          <el-button
            type="primary"
            size="mini"
            class="bg5584FF"
            @click="sureDelete"
            >确定</el-button
          >
          <el-button
            type="normal"
            size="mini"
            @click="deleteDialogVisible = false"
            >取消</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { Message } from "element-ui";
export default {
  data() {
    // 手机号验证
    var checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
      if (!value) {
        callback();
        // return callback(new Error("电话号码不能为空")); 必填验证  此处非必填
      }
      setTimeout(() => {
        if (!Number.isInteger(+value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (phoneReg.test(value)) {
            callback();
          } else {
            callback(new Error("电话号码格式不正确"));
          }
        }
      }, 100);
    };
    //
    var onlyCode = (rule, value, callback) => {
      if (!value) {
        // callback();
        return callback(new Error("请输入登录账号"));
      } else {
        this.$axios
          .get(`/system/user/searchNameOrLoginNameIsExisted`, {
            params: {
              loginName: value,
            },
          })
          .then((res) => {
            if (res.data >= 1) {
              callback(new Error("登录账号已存在"));
            } else if (res.data == 0) {
              callback();
            }
          });
      }
    };
    return {
      addDialogVisible: false, // 新增用户
      detailDialogVisible: false, //查看用户
      allotDialogVisible: false, //分配角色
      editDialogVisible: false, //编辑用户
      deleteDialogVisible: false, //删除
      currentPage: 1,
      pageNum: 1, //默认请求第一页表格数据
      total: 0, //表格总数
      loading: false,
      addloading: false,
      editloading: false,
      superDepartmentList: [],
      superParktList: [],
      roleIds: [], //角色id
      id: "", //用户id
      allotRole: {},
      formInline: {
        //查询对象
        name: "",
        loginName: "",
        type: "",
      },
      tableData: [], //表格数组
      ruleForm: {
        //提交表单
        name: "",
        loginName: "",
        type: "政府用户",
        department: "",
        garden: "",
        creditCode: "",
        state: 0,
        mobilePhone: "",
        landLine: "",
        email: "",
      },
      editRuleForm: {
        //查看和修改表单
        name: "",
        loginName: "",
        type: "",
        department: "",
        garden: "",
        creditCode: "",
        state: "",
        phone: "",
        landline: "",
        email: "",
      },
      rules: {
        //表单验证规则
        name: [{ required: true, message: "请输入用户名称", trigger: "blur" }],
        loginName: [
          {
            required: true,
            validator: onlyCode,
            trigger: "blur",
          },
        ],
        type: [
          { required: true, message: "请选择用户类型", trigger: "change" },
        ],
        department: [
          { required: true, message: "请选择部门", trigger: "change" },
        ],
        garden: [{ required: true, message: "请选择园区", trigger: "change" }],
        creditCode: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "blur",
          },
        ],
        state: [
          { required: true, message: "请选择用户状态", trigger: "change" },
        ],
        mobilePhone: [
          { required: false, validator: checkPhone, trigger: "blur" },
        ],
      },
      userAllotTableData: [
        //权限分配数组
        {
          name: "市级一般角色",
          code: "yxc",
          status: "0",
        },
        {
          name: "区县一般角色",
          code: "fzc",
          status: "1",
        },
      ],
    };
  },
  created() {
    this.getdata(this.pageNum);
    this.getDeptList();
    this.getParkList();
    this.getuserAllotList();
  },
  methods: {
    getdata(pageNum) {
      this.loading = true;
      this.$axios
        .get("/system/user/searchUserPageList", {
          params: {
            pageNum,
            pageSize: 10,
            name: this.formInline.name,
            loginName: this.formInline.loginName,
            type: this.formInline.type,
          },
        })
        .then((res) => {
          this.loading = false;
          this.tableData = res.data;
          this.total = res.total;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
    getDeptList() {
      this.$axios.get("/system/department/searchAllDepartment").then((res) => {
        this.superDepartmentList = res.data;
      });
    },
    getParkList() {
      this.$axios.get("/business/park/selectParkNames").then((res) => {
        this.superParktList = res.data;
      });
    },
    getuserAllotList() {
      this.$axios
        .get(`/system/role/searchRolePageList`, {
          params: {
            pageSize: 100,
            pageNum: 1,
          },
        })
        .then((res) => {
          this.userAllotTableData = res.data;
        });
    },
    onSubmit() {
      //查询
      console.log(this.formInline);
      this.getdata(this.pageNum);
    },
    reset() {
      //重置
      for (const key in this.formInline) {
        this.formInline[key] = "";
      }
      this.pageNum = 1;
      this.getdata(this.pageNum);
      this.currentPage = 1;
    },
    handleManage(index, row) {
      //分配角色
      console.log(index, row);
      this.allotDialogVisible = true;
      this.id = row.id;
      this.$axios
        .get(`/system/user/searchUserOwnsRole/${row.id}`)
        .then((res) => {
          console.log(res);
          this.userAllotTableData.map((row) => {
            if (res.data.includes(row.id)) {
              this.$refs.multipleTable.toggleRowSelection(row, true);
            }
          });
        });
    },
    handleDetail(row) {
      //查看用户
      this.detailDialogVisible = true;
      this.$axios.get(`/system/user/selectUserDetail/${row.id}`).then((res) => {
        this.editRuleForm = res.data;
      });
    },
    handleEdit(index, row) {
      //编辑
      this.editDialogVisible = true;
      this.editloading = true;
      this.$axios
        .get(`/system/user/selectUserDetail/${row.id}`)
        .then((res) => {
          this.editRuleForm = res.data;
          this.editloading = false;
        })
        .catch(() => {
          this.editloading = false;
        });
    },
    handleDelete(index, row) {
      //删除
      this.deleteDialogVisible = true;
      this.id = row.id;
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      //跳转页
      this.getdata(val);
    },
    submitForm(formName) {
      //新增提交
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.loginName = this.ruleForm.loginName.toLowerCase();
          console.log(this.ruleForm);
          this.addloading = true;
          this.$axios
            .post("/system/user/insertUserInfo", this.ruleForm)
            .then((res) => {
              this.addloading = false;
              Message.success("新增成功");
              this.ruleForm.landLine = "";
              this.ruleForm.email = "";
              this.addDialogVisible = false;
              this.getdata(this.pageNum);
            })
            .catch(() => {
              this.addloading = false;
            });
        } else {
          // Message.error("请完善表单信息");
          return false;
        }
      });
    },
    addDialogHandleClose() {
      this.ruleForm.landLine = "";
      this.ruleForm.email = "";
      this.$refs.ruleForm.resetFields();
    },
    editHandleClose() {
      this.$refs.editRuleForm.resetFields();
    },
    allotHandleClose() {
      this.userAllotTableData.map((row) => {
        this.$refs.multipleTable.toggleRowSelection(row, false);
      });
    },
    editSubmitForm(formName) {
      //修改提交
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editloading = true;
          this.$axios
            .put("/system/user/updateUserIfo", this.editRuleForm)
            .then((res) => {
              Message.success("编辑成功");
              console.log(1111);
              this.editloading = false;
              this.editDialogVisible = false;
              this.editRuleForm.landLine = "";
              this.editRuleForm.email = "";
              this.getdata(this.pageNum);
            })
            .catch(() => {
              this.editloading = false;
            });
        } else {
          // Message.error("请完善表单信息");
          return false;
        }
      });
    },
    handleSelectionChange(selection) {
      this.roleIds = [];
      selection.forEach((item) => {
        this.roleIds.push(item.id);
      });
    },
    onSaveAllot() {
      //分配角色提交
      this.allotRole.roleIds = this.roleIds;
      this.allotRole.userId = this.id;
      console.log(this.allotRole);
      this.$axios
        .post("/system/user/defineUserOwnsRole", this.allotRole)
        .then(() => {
          Message.success("已分配");
          this.allotDialogVisible = false;
        });
    },
    sureDelete() {
      // 删除
      this.$axios
        .delete(`/system/user/deleteUserIfo/${this.id}`)
        .then(() => {
          Message.success("删除成功");
          this.deleteDialogVisible = false;
          this.getdata(this.pageNum);
        })
        .catch(() => {
          Message.success("删除失败");
          this.deleteDialogVisible = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.content_box {
  padding: 20px 30px 30px;
}
@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
}
.userManage {
  box-shadow: 0px 0px 50px #ccc;
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  .userManage_header {
    height: 31px;
    width: 100%;
    display: flex;
    margin-bottom: 30px;
    .userManage_logo {
      margin: 2px 20px 0 2px;
    }
    h3 {
      font-size: 24px;
      height: 100%;
      margin: 0;
      color: #444444;
    }
  }
  .userManage_form {
    height: 70px;
    width: 100%;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(155, 155, 155, 0.25);
    margin-bottom: 20px;
    .el-form {
      .el-form-item {
        margin-right: 30px;
      }
    }
  }
  .userManage_add_user {
    margin-bottom: 20px;
  }
  .el-dialog {
    .addUser {
      .el-form-item {
        .el-select {
          width: 100%;
        }
      }
    }
  }
}
.detail {
  width: 100%;
  height: 100%;
  cursor: pointer;
  color: #5584ff;
}
</style>